var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0783 34.0867H28.155V24.805C28.155 22.5917 28.11 19.7433 25.0683 19.7433C21.98 19.7433 21.5083 22.1517 21.5083 24.6417V34.0867H15.585V15H21.275V17.6017H21.3517C22.1467 16.1017 24.08 14.5183 26.9683 14.5183C32.97 14.5183 34.08 18.4683 34.08 23.61V34.0867H34.0783ZM8.895 12.3883C6.98833 12.3883 5.45667 10.845 5.45667 8.94667C5.45667 7.05 6.99 5.50833 8.895 5.50833C10.795 5.50833 12.335 7.05 12.335 8.94667C12.335 10.845 10.7933 12.3883 8.895 12.3883ZM11.865 34.0867H5.925V15H11.865V34.0867ZM37.0417 0H2.95167C1.32 0 0 1.29 0 2.88167V37.1183C0 38.7117 1.32 40 2.95167 40H37.0367C38.6667 40 40 38.7117 40 37.1183V2.88167C40 1.29 38.6667 0 37.0367 0L37.0417 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d08c58f215617b0c86427185005c70aa.svg";
export { ForwardRef as ReactComponent };